const actionTypeIdentifier = '4B78D49F-068A-48E5-8983-89813BF9FF12'; //action identifier should be unique

//approver data
export const setRequestTypes = `SET-ORDER-REQUEST-TYPES-${actionTypeIdentifier}`;
export const setIsWirelineRequest = `SET-ORDER-IS-WIRELINE-REQUEST-${actionTypeIdentifier}`;
export const setUpdateDataList = `SET-UPDATE-DATA-LIST-${actionTypeIdentifier}`;
export const setTypeOfRequest = `SET-ORDER-TYPE-OF-REQUEST-${actionTypeIdentifier}`;
export const setIsRequestOnBehalf = `SET-ORDER-IS-REQUEST-ON-BEHALF-${actionTypeIdentifier}`;
export const setRequestOnBehalfData = `SET-ORDER-REQUEST-ON-BEHALF-DATA-${actionTypeIdentifier}`;
export const setRequestOnBehalfManagerData = `SET-ORDER-REQUEST-ON-BEHALF-MANAGER-DATA-${actionTypeIdentifier}`;
export const setSubscriptionList = `SET-CREATE-REQUEST-ORDER-SUBSCRIPTION-LIST-${actionTypeIdentifier}`;
export const setPrimarySubscriptionList = `SET-CREATE-REQUEST-ORDER-PRIMARY-SUBSCRIPTION-LIST-${actionTypeIdentifier}`;
export const setEmployeeList = `SET-CREATE-REQUEST-ORDER-EMPLOYEE-LIST-${actionTypeIdentifier}`;
export const setAddressList = `SET-CREATE-REQUEST-ORDER-ADDRESS-LIST-${actionTypeIdentifier}`;
export const setGLCodeList = `SET-CREATE-REQUEST-ORDER-GL-CODE-LIST-${actionTypeIdentifier}`;
export const setCostCenterList = `SET-CREATE-REQUEST-ORDER-COST-CENTER-LIST-${actionTypeIdentifier}`;
export const resetRequestData = `RESET-CREATE-REQUEST-REQUEST-DATA-${actionTypeIdentifier}`;
export const setExhibitType = `SET-CREATE-REQUEST-EXHIBIT-TYPE-${actionTypeIdentifier}`;
export const setTakeActionCircuitCode = `SET-CREATE-REQUEST-TAKE-ACTION-CIRCUIT-CODE-${actionTypeIdentifier}`;
export const setTakeActionSubScriptionDetail = `SET-CREATE-REQUEST-TAKE-ACTION-SUBSCRIPTION-CODE-${actionTypeIdentifier}`;
export const setIsUpdateRequest = `SET-IS-UPDATE-ORDER-REQUEST-${actionTypeIdentifier}`;
export const setIsRequestBehalfToggle = `SET-IS-REQUEST-BEHALF-TOGGLE-${actionTypeIdentifier}`;







